(() => {
  'use strict';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const addReveal = (el, type = '') => {
    if (!el || el.hasAttribute('data-phox-reveal')) return;
    el.setAttribute('data-phox-reveal', type);
  };

  const prepareExistingSections = () => {
    document.querySelectorAll('.phox-hero').forEach((section) => {
      section.classList.add('is-phox-ready');
      addReveal(section.querySelector('.phox-hero__eyebrow'));
      addReveal(section.querySelector('.phox-hero__heading'));
      addReveal(section.querySelector('.phox-hero__text'));
      addReveal(section.querySelector('.phox-hero__actions'));
      addReveal(section.querySelector('.phox-hero__proof'));
      section.querySelectorAll('.phox-hero-benefit').forEach((card, index) => {
        addReveal(card);
        card.style.setProperty('--phox-reveal-delay', `${index * 90}ms`);
      });
      const heroImg = section.querySelector('.phox-hero__image');
      if (heroImg) heroImg.setAttribute('data-phox-parallax', '18');
    });

    document.querySelectorAll('.phox-performance').forEach((section) => {
      addReveal(section.querySelector('.phox-performance__header'));
      section.querySelectorAll('.phox-performance-card').forEach((card, index) => {
        addReveal(card);
        card.style.setProperty('--phox-reveal-delay', `${index * 100}ms`);
      });
      addReveal(section.querySelector('.phox-performance__button'));
    });

    document.querySelectorAll('.phox-loadout').forEach((section) => {
      addReveal(section.querySelector('.phox-loadout__header'));
      section.querySelectorAll('.phox-loadout-card').forEach((card, index) => {
        addReveal(card);
        card.style.setProperty('--phox-reveal-delay', `${Math.min(index, 5) * 70}ms`);
      });
      addReveal(section.querySelector('.phox-coffee-profile'));
    });
  };

  const setupRevealObserver = () => {
    const els = [...document.querySelectorAll('[data-phox-reveal]')];
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-phox-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-phox-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });
    els.forEach((el) => observer.observe(el));
  };

  const setupParallax = () => {
    if (reduceMotion) return;
    const els = [...document.querySelectorAll('[data-phox-parallax]')];
    if (!els.length) return;
    let ticking = false;
    const update = () => {
      const h = window.innerHeight || 1;
      els.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.bottom < -120 || rect.top > h + 120) return;
        const amount = Number(el.getAttribute('data-phox-parallax')) || 18;
        const center = rect.top + rect.height / 2;
        const progress = (center - h / 2) / h;
        el.style.setProperty('--phox-parallax-y', `${Math.max(-amount, Math.min(amount, progress * -amount * 2))}px`);
      });
      ticking = false;
    };
    const request = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };
    addEventListener('scroll', request, { passive: true });
    addEventListener('resize', request, { passive: true });
    request();
  };

  const setupScrollStories = () => {
    document.querySelectorAll('[data-phox-scrollstory]').forEach((story) => {
      const cards = [...story.querySelectorAll('[data-phox-story-card]')];
      if (!cards.length) return;
      const progress = story.querySelector('[data-phox-story-progress]');
      const activate = (card) => {
        cards.forEach((item) => item.classList.toggle('is-active', item === card));
        const index = Math.max(0, cards.indexOf(card));
        const pct = cards.length === 1 ? 100 : ((index + 1) / cards.length) * 100;
        if (progress) progress.style.setProperty('--phox-story-progress', `${pct}%`);
      };
      activate(cards[0]);
      if (reduceMotion || !('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver((entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio);
        if (visible[0]) activate(visible[0].target);
      }, { threshold: [0.25, 0.5, 0.75], rootMargin: '-15% 0px -25% 0px' });
      cards.forEach((card) => observer.observe(card));
    });
  };

  const init = () => {
    prepareExistingSections();
    setupRevealObserver();
    setupParallax();
    setupScrollStories();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', () => setTimeout(init, 0));
})();
